import { useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

import EguCostInfoCreateDialog from "../dialogTypes/EguCostInfoCreateDialog";


function EguCostInfoCreateButton(props) {
    const { t } = useTranslation();

    const {
        id,
        schema,
        onSuccess,
        createButtonName,
        modifyUrlCallback,
        customizeErrorMsgCallback,
        title,
        refresh,
        appendCheckBox,
        ...others
    } = props;

    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        refresh.refresh();
    };

    return (
        <>
            <CreateRecordButtonLayout
                id={id + "create-button"}
                onClick={onOpen}
                createButtonName={createButtonName}
                {...others}
            />

            <EguCostInfoCreateDialog
                id={id + "create-dialog"}
                mode="create"
                formId={id + "create-form"}
                title={schema ? t(`dialog.title.${schema.name}.create`) : ""}
                schema={schema}
                open={open}
                appendCheckBox={appendCheckBox}
                onClose={onClose}
                onSuccess={onCreateSuccess}
            />

        </>
    );
}

export default EguCostInfoCreateButton;
